export enum Navigation {
  None = 'NONE',
  Import = 'IMPORT',
  Search = 'SEARCH',
  // Product Navigation
  HandTools = 'HAND TOOLS',
  PowerTools = 'POWER TOOLS',
  PPE = 'PPE',
  Storage = 'STORAGE',
  Corded = 'CORDED',
  M12 = 'M12',
  M18 = 'M18',
  MXFuel = 'MX FUEL',
}
